import axios from "axios";
import React, {Component} from "react";
import ScheduleForm from "./ScheduleForm";
import Select from 'react-select';
import FeatherIcon from 'feather-icons-react';
import ReactToPrint from "react-to-print";
import Headerpdf from "../../users/Headerpdf";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
// import Drop from "./Drop";

class   Schedule extends Component{

    state = {
        isModal : false,
        formData : null,
        periode : null,
        periodeId : null,
        sectionclasse : "",
        scheduleDiplique : [],
        schedules : [],
        periodes : [],
        sections : [],
        days : [],
        staffs : [],
        laoding : false,
    }

    componentDidMount(){
        this.getPeriodes();
        this.getSchedules()
        this.getSections();
        this.getDays();
        this.getStaffs()
    }

    async getSchedules( periode = null){
        let peri = this.state.periodes?.sort((a, b) => a.id > b.id ? -1 : 1).filter(val => val.statut == 1)
        let per = periode || this.state.periode || peri[0]?.id
        var schedules = await axios.get('schedules/periodeId/' + per);
        if(schedules.status === 200)
        {
            this.setState({schedules : schedules.data, periode : per, laoding : true}) 
        }
    }

    async getStaffs(){
        var staffs = await axios.get('staffs');
        if(staffs.status === 200)
        {
            this.setState({staffs : staffs.data}) 
        }
    }

    async getSections(){
        var sections = await axios.get('sections');
        if(sections.status === 200)
        {
            this.setState({sections : sections.data}) 
        }
    }

    async getDays(){
        var days = await axios.get('days');
        if(days.status === 200)
        {
            this.setState({days : days.data}) 
        }
    }

    async getPeriodes(){
        var periodes = await axios.get('periodes');
        if(periodes.status === 200)
        {
            periodes.data?.map(period => {
                if(period.statut == 1)
                    this.getSchedules(period.id);
            })
            this.setState({periodes : periodes.data, laoding : true}) 
        }
    }

    showModalD = ( sectionclass = null ) => {

       let schedules =  this.state.schedules.filter(schedule => this.state.periode && schedule?.periode?.id === this.state.periode  && schedule.sectionclasselesson?.sectionclass?.id == sectionclass.id)
        
        this.setState({
            scheduleDiplique : schedules
        })
    }

    handleInput = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        }); 
    }

    storeLesson = () =>{
        this.state.scheduleDiplique?.map((val) =>{
            var data = {
                sectionclasselessonId: val.sectionclasselesson?.id || null,
                staffId : val.staff?.id,
                dayId : val.dayId ? val.dayId : null,
                periodeId : this.state.periodeId ? this.state.periodeId : null,
                date_start : val.date_start ? val.date_start : null,
                date_end : val.date_end ? val.date_end : null,
                time_start : val.time_start ? val.time_start : null,
                time_end : val.time_end ? val.time_end : null,
                operation :  "Ajouter"
            }
    
            var request = axios.post('schedules', data);
            request.then((response) =>{
                toast(response?.data?.msg, { theme : "light", style : { backgroundColor : "blue", color : "white"}})
            }).catch((error) => {
                this.setState({
                    error : error.response.data.msg
                })
                toast(error.response?.data?.msg, { theme : "light", style : { backgroundColor : "red", color : "white"}})
            })
        })
        this.setState({
            scheduleDiplique : [],
            periodeId : null
        })
    }

    showModal = (schedule = null, sectionclasse = null) => {
        this.setState({
            sectionclasse : sectionclasse,
            isModal : !this.state.isModal,
            formData :  schedule,
        })
        this.getPeriodes()
        if(schedule == 1)
            this.getSchedules(this.state.periode)
    }

    delete = (schedule) =>{
        axios.delete("schedules/" + schedule).then((response) => {
            this.getPeriodes()
        }).catch((error)=>{})
    }

  handleCheck(val) {
    var permissions = localStorage.getItem("permissions") ? JSON.parse(localStorage.getItem("permissions")) : [];
     return  permissions.some(item => val === item.permission);
 }

    render(){
        let schendules = []
        var schedules =
        this.state.sections.sort((a, b) => (a.short_entitled_section > b.short_entitled_section ? 1 : -1)).map((section) =>{
            
            return(
                section.sectionclasses?.sort((a, b) => ((a.class.short_entitled_class > b.class.short_entitled_class ) ? 1 : -1)).map((sectionclass) =>{
                    
                    // if(!schendules[sectionclass?.id])
                    //     schendules[sectionclass?.id] = []
                    return(
                        <li className="widget-todo-item list-group-item m-2   border rounded-3 shadow">
                            <div
                                className="widget-todo-title-wrapper d-flex justify-content-between align-items-center  ">
                                <div className="widget-todo-title-area d-flex align-items-center">
                                {
                                    this.handleCheck("Ajouter horaire") == true && (
                                        <div className="btn-toolbar m-0 mb-md-0 table_action ">
                                            <div className="btn-group">
                                                <button type="button" className="btn btn-sm text-primary" onClick={() => this.showModal(null, sectionclass)}><FeatherIcon icon="plus-circle" ></FeatherIcon></button>
                                            </div>
                                        </div>
                                    )
                                }<FeatherIcon icon="box" className='cursor-move'></FeatherIcon>
                                    <label htmlFor={sectionclass.id}><span className="widget-todo-title ml-50">{sectionclass.class.short_entitled_class}  <span className="text-primary">{sectionclass.title}</span> { section.short_entitled_section} </span></label>
                                </div>
                                <div className="widget-todo-item-action d-flex align-items-center">
                                    
                                    <b>{section.entitled_section}</b> <FeatherIcon icon="list" size="16" className='cursor-move text-dark'></FeatherIcon>
                                    {
                                        this.handleCheck("Supprimer horaire") == true && (
                                            <button type="button" className="btn btn-sm text-danger table_action" onClick={() => this.showModalD(sectionclass)}><FeatherIcon icon="shuffle" ></FeatherIcon></button>
                                        )
                                    }
                                </div>
                            </div>
                            <div className="table-responsive m-2">

                                <div className="d-none">
                                    <div className="text-center h6">
                                        <label htmlFor={sectionclass.id}><span className="widget-todo-title ml-50">Horaire { sectionclass.class.short_entitled_class } { sectionclass.class.entitled_class } <span className="text-primary">{sectionclass.title}</span> { section.short_entitled_section} </span></label>
                                    </div>
                                </div>
                                <table className="table table-striped table-sm">
                                    <thead>
                                        <tr>
                                        {
                                            this.state.days.map((day) => {
                                                return(<th className="border" scope="col" key={day.id +"evivesoma"}> {day.day}</th>)
                                                })
                                        }
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            this.state.days.map((day) => {
                                                if(!schendules[day.id])
                                                    schendules[day.id] = []
                                                return (
                                                        <td className="border" key={day.id}>
                                                            <ul>
                                                            {
                                                                this.state.schedules.filter(schedule => this.state.periode && schedule?.periode?.id === this.state.periode  && schedule.sectionclasselesson?.sectionclass?.id == sectionclass.id && schedule.dayId == day.id || !this.state.periode && schedule.sectionclasselesson?.sectionclass?.id == sectionclass.id && schedule.dayId == day.id).map((schedule) => {
                                                                    if(!schendules[day.id][sectionclass.id])
                                                                        schendules[day.id][sectionclass.id] = []
                                                                    schendules[day.id][sectionclass.id].push({
                                                                        hour : schendules[day.id][sectionclass.id]?.length,
                                                                        teacher : schedule.staff?.user?.last_name,
                                                                        lesson : schedule.sectionclasselesson?.lesson?.short_entitled_lesson,
                                                                    })
                                                                    
                                                                    return(
                                                                    <li key={schedule.id} type="button" title={"modifier " + (schedule.date_start || '') + " au " + (schedule.date_end ||'') } onClick={ () => this.showModal(schedule, sectionclass)} className=" align-items-center  p-1 border mt-1 fw-normal rounded-3" >
                                                                        <label htmlFor={day.id}><span className="  ps-2 widget-todo-title "> { schedule.sectionclasselesson?.lesson?.short_entitled_lesson} </span></label>  
                                                                        <span className="text-primary ps-2" style={{ fontSize : 9}} >{ schedule.staff?.user?.last_name?.slice(0, 4) }</span>
                                                                        <span className="fw-lighter" style={{ fontSize : 9 +"px"}}> { schedule.hour ? schedule.hour : schedule.time_start ? schedule.time_start.slice(0, 5) : "" }  </span>
                                                                    </li> 
                                                                    )
                                                                })
                                                            }
                                                            </ul>
                                                        </td>
                                                )
                                            })
                                        }
                                    </tbody>
                                </table>
                                
                            </div>
                        </li>
                    )
                })
            )
        })

       


        var optionPeriodes = [ ];
        this.state.periodes.map(periode => {
            optionPeriodes.push({ value : periode.id, label : periode.periode })
        })
        return(
            <div>
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                <h5 className="h5 font-monospace">Horaire { (this.state.periodes && this.state.periode > 0) ? this.state.periodes[this.state.periode -1]?.periode : '' } {(this.state.periode == 1 || this.state.periode ==2 || this.state.periode == 4 || this.state.periode == 5) ? ' periode' : '' } <small className="fw-lighter text-primary small" style={{ fontSize : 11 +"px"}}>{this.state.periode!= 3 && this.state.periode!= 6 && this.state.periode!= 7 ? "("+this.state.periode+ "P)" : "" }{this.state.periode== 3 ? "(Exa1)" : "" }{this.state.periode== 6 ? "(Exa2)" : "" }{this.state.periode== 7 ? "(2°S)" : "" }</small> </h5>
                <div>
                    <Link to="/propositions">Porposition</Link>
                </div>
                <div className="">
                    <Select className="form-control form-control-sm"
                        value = {
                            optionPeriodes.filter(option => 
                            option.value === this.state.periode)
                        }
                        defaultValue={this.state.periode}
                        onChange={
                            (select) => {
                                this.setState({ periode : select.value });
                                this.getSchedules(select.value)
                            }
                        }
                        options={optionPeriodes}
                    />
                </div>
                
            </div>

            <div className={ this.state.scheduleDiplique?.length > 0 ? '' : 'd-none'}>
                <div>
                    <label>Dipliquer <span className="widget-todo-title ml-50">{this.state.scheduleDiplique[0]?.sectionclasselesson?.sectionclass?.class?.short_entitled_class} <span className="text-primary">{ this.state.scheduleDiplique[0]?.sectionclasselesson?.sectionclass?.title}</span>  {this.state.scheduleDiplique[0]?.sectionclasselesson?.sectionclass?.section?.short_entitled_section} </span></label>
                </div>
                <div>
                    <select name="periodeId" className=" m-2 form form-control form-control-sm" onChange={ this.handleInput }>
                        {
                            this.state.periodes?.map((val) => (
                                <option value={val.id}>{ val?.periode }</option>
                            ))
                        }
                    </select>
                </div>
                <button onClick={() => this.storeLesson()} className="btn btn-sm btn-outline-primary p-0 px-1"><FeatherIcon icon="check-square"></FeatherIcon> Dipliquer</button>
        
            </div>

            <div className="row">
                
                {/* <Drop />
                { 
                    this.state.sections.sort((a, b) => (a.short_entitled_section > b.short_entitled_section ? 1 : -1)).map((section) =>{
                        return(
                            section.sectionclasses?.sort((a, b) => ((a.class.short_entitled_class > b.class.short_entitled_class && a.title > b.title) ? 1 : -1)).map((sectionclass) =>{
                                schendules?.map((day, index) =>{
                                    return(
                                        day[sectionclass?.id]?.map(shendu =>{
                                            
                                        })
                                    )
                                })
                            })
                        )
                    })
                } */}
                <div className="col-md-12">
                    <div className="text-end mb-2 mb-md-0">
                        <div className="btn-group me-2">
                            <ReactToPrint
                                trigger={() => <button className="btn btn-sm btn-outline-primary" type="button"><FeatherIcon icon={"printer"} size="22"></FeatherIcon> <span className="d-none d-sm-inline">Imprimer</span></button>}
                                content={() =>  this.componentRef}
                            />
                        </div>
                    </div>
                    <ul className="widget-todo-list-wrapper p-0"  ref={el => (this.componentRef = el)}>
                        <Headerpdf />
                            { this.state.laoding ?  schedules : <FeatherIcon className="user-search-spin" icon="loader" /> }
                    </ul>
                </div>
            </div>
            
            
            <ScheduleForm 
                isModal={this.state.isModal} 
                formData={this.state.formData} 
                sectionclasse = {this.state.sectionclasse}
                showModal={this.showModal}
            />
            
        </div>
        )
    }
}
export default Schedule;